import { IImportModel } from '../importer/model';

export const productsImportDomainSelector = (state: any): IImportModel =>
  state.productsImport as IImportModel;
